// extracted by mini-css-extract-plugin
export default {"wrapper":"document_wrapper__MFXMP","content":"document_content__qHMk8","containerRef":"document_containerRef__Tgx1y","reference":"document_reference__dUTds"};